import { ReportDeviation } from './ReportDeviation';

export default ReportDeviation;
